class Subscription {
  constructor(unsubscribe) {
    this.unsubscribe = unsubscribe;
  }
}

export default Subscription;
